/**
 * 溯源 store
 */

import axios from "../../utils/axios";
import { handleSensorData } from "../../utils/tool";

import localstore from "../../utils/localStorge";

let state = {
  traceId: 0,
  traceArray: "",
  name: "",
  report: [],
  plants: [],
  plantWork: {
    task: [],
    pages: 0,
    total: 0
  },
  plantMessage: {
    name: "",
    category: "",
    scale: "",
    startTime: "",
    picture: ""
  },
  farmMessage: {
    name: "",
    area: "",
    linkman: "",
    phone: "",
    address: "",
    gps: [],
    picture: ""
  },
  envIndex: 0,
  envTotal: 0,
  showEnvMessage: [],
  environmentMessage: []
};

let getters = {
  getProductName(state) {
    return state.name;
  },
  getFarmMessage(state) {
    return state.farmMessage;
  },
  getPlantMessage(state) {
    return state.plantMessage
  },
  getReport(state) {
    return state.report
  },
  getPlantWork(state) {
    return state.plantWork
  },
  getEnvironMessage(state) {
    return state.environmentMessage;
  },
  getEnvMessage(state) {
    return state.showEnvMessage;
  },
  getPlants(state) {
    return state.plants;
  }
};

let  mutations = {
  setEnvMessageGroup(state) {
    if (state.envTotal.length < 5) return;
    if (state.envIndex >= state.envTotal) {
      state.envIndex = 0;
    }
    let result = [];
    for(let i = 1; i <= 5; i++) {
      if (state.envIndex + i < state.envTotal) {
        result.push(state.environmentMessage[envIndex + i]);
      }
    }
    state.showEnvMessage = result;
    state.envIndex += 5;
  },
  setTraceMessage(state, payload) {
    state.name = payload.traceMessage.name;
    state.traceId = payload.traceMessage.id;
    state.report = payload.traceMessage.report_img;
  },
  setTracePlantWorkMessage(state, payload) {
    state.plantWork.task.push(...payload.task);
    state.plantWork.pages = payload.pages;
    state.plantWork.total = payload.total;
  },
  setTracePlantMessage(state, payload) {
    state.plantMessage.name = payload.name;
    state.plantMessage.category = payload.category;
    state.plantMessage.scale = payload.scale;
    state.plantMessage.startTime = payload.startTime;
    state.plantMessage.picture = payload.picture;
  },
  setFarmMessage(state, payload) {
    state.farmMessage.name = payload.name;
    state.farmMessage.area = payload.area;
    state.farmMessage.linkman = payload.linkman;
    state.farmMessage.phone = payload.phone;
    state.farmMessage.address = payload.address;
    state.farmMessage.gps = payload.gps;
    state.farmMessage.picture = payload.picture;
    state.farmMessage.pictures = payload.pictures;
  },
  setEnvironmentMessage(state, payload) {
    state.environmentMessage = payload.environmentMessage;
    state.envTotal = payload.environmentMessage.length;
  },
  setPlants(state, payload) {
    state.plants = payload.plants;
  },
  setTraceId(state, payload) {
    localstore.set("cropIndex", payload.index);
    state.name = state.plants[payload.index].key;
    state.traceId = state.plants[payload.index].value;
  },
  setClearFarmWork(state) {
    state.plantWork.task = [];
  }
};

let actions = {
  traceFarmWork({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios.post("https://backend-zs.farmapi.xiaomaiot.com/v4/trace/planting_work", {
        id: payload.id,
        page: payload.page
      })
      .then(res => {
        if (res.status === 200 && res.data.data.length !== 0) {
          let taskInfo = res.data.data.items;
          let tasks = [];
          for (let i = 0; i < taskInfo.length; ++i) {
            let taskTime = !!taskInfo[i].start_time ? taskInfo[i].start_time.split(" ")[0] : '';
            tasks.push({
              id: taskInfo[i].id,
              workerName: taskInfo[i].worker_name,
              machineName: taskInfo[i].machine_name,
              task: taskInfo[i].type_name,
              time: taskTime
            });
          }
          commit("setTracePlantWorkMessage", {
            task: tasks,
            pages: res.data.data.pages,
            total: res.data.data.total
          });
        }
        resolve();
      })
      .catch(error => {
        console.log(error);
        reject();
      });
    });
  },
  tracePlant({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios.post("https://backend-zs.farmapi.xiaomaiot.com/v4/trace/planting", {
        id: payload.id
      })
      .then(res => {
        // console.log(res);
        if (res.status === 200 && res.data.data.length !== 0) {
          commit("setTracePlantMessage", {
            name: res.data.data.name,
            category: res.data.data.plant_category,
            scale: res.data.data.scale,
            startTime: res.data.data.start_time.split(" ")[0],
            picture: res.data.data.picture
          });
        }
        resolve();
      })
      .catch(error => {
        console.error(error);
        reject();
      });
    });
  },
  traceFarmMessage({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios.post("https://backend-zs.farmapi.xiaomaiot.com/v4/trace/farm", {
        id: payload.id
      })
      .then(res => {
        // console.log(res);
        if (res.status === 200 && res.data.data.length !== 0) {
          commit("setFarmMessage", {
            name: res.data.data.name,
            area: res.data.data.area,
            linkman: res.data.data.linkman,
            phone: res.data.data.phone,
            address: res.data.data.address,
            gps: res.data.data.gps,
            picture: res.data.data.pictures.length > 0 ?  res.data.data.pictures[0] : "",
            pictures: res.data.data.pictures
          });
          resolve();
        }
      })
      .catch(error => {
        console.error(error);
        reject();
      });
    });
  },
  traceId({commit, rootState}, payload) {
    return new Promise((resolve, reject) => {
      axios.get(`/trace?farm_id=${rootState.farmId}`)
      .then(res => {
        // console.log(res);
        // 某农作物的溯源索引
        let index = payload.index;
        if (localstore.get("cropIndex") !== null) {
          index = localstore.get("cropIndex");
        }
        if (res.status === 200 && res.data.data.length !== 0) {
          let traceData = res.data.data;
          // 默认显示第一个信息
          commit("setTraceMessage", {
            traceMessage: traceData[index]
          });
          // 确定有多少个溯源农作物
          let plants = [];
          traceData.forEach(item => {
            plants.push({
              key: item.name,
              value: item.id
            });
          });
          commit("setPlants", {
            plants: plants
          });
          // 环境信息
          let deviceData = traceData[index].device_data !== null ? traceData[index].device_data.type: [];
          let cache = {};
          let result = [];
          for(let i = 0; i < deviceData.length; ++i) {
            let item = {
              data_class: deviceData[i].data_class,
              max_number: deviceData[i].data[0].max_number,
              mean_number: deviceData[i].data[0].mean_number,
              min_number: deviceData[i].data[0].min_number,
              time: deviceData[i].data[0].time,
            };
            !cache[item.data_class] ? cache[item.data_class] = 1 : cache[item.data_class]++;
            item = handleSensorData(item);
            item.number = cache[item.data_class];
            result.push(item);
          }
          commit("setEnvironmentMessage", {
            environmentMessage: result
          });
          resolve();
        } else {
          reject();
        }
      })
      .catch(error => {
        console.error(error);
        reject();
      });
    });
  },
  traceMessage({state, commit, dispatch}, payload) {
    return new Promise(async (resolve, reject) => {
      await dispatch("traceId", {
        index: payload.index
      }).catch(error => {
        reject();
      });
      commit("setClearFarmWork");
      await dispatch("traceFarmWork", {
        id: state.traceId,
        page: 1
      });
      for (let i = 2; i < state.plantWork.pages.length; ++i) {
        await dispatch("traceFarmWork", {
          id: state.traceId,
          page: i
        });
      }
      await dispatch("tracePlant", {
        id: state.traceId
      });
      await dispatch("traceFarmMessage", {
        id: state.traceId
      });
      resolve();
    });
  }
};

export default {
  state,
  getters,
  actions,
  mutations
}
